import React, { PureComponent, Fragment } from 'react';
import { Table } from 'reactstrap';
import Panel from '../../../../../shared/components/Panel';
import { getDefaultChartColors } from '../../../../../shared/helpers';
import ToolTip from '../../../../../shared/components/ToolTip';

const _bedLabel = (key) => {
	if (key <= 0) return 'Studio';
	if (key >= 4) return '4+ Bed';
	return `${key} Bed`;
};

const _bedSearch = (key) => {
	if (key <= 0) return 'studio';
	if (key >= 4) return '4-or-more';
	return `${key}-bedroom`;
};

const _bedKey = (val) => (val >= 4 ? 4 : Math.max(0, val));

// Merge per-bedroom facet buckets into rows keyed by display bucket (0,1,2,3,4+).
// For 4+ we keep counts as the sum, but pull medians from the largest sub-bucket
// to avoid combining percentiles incorrectly.
const _mergeByBedKey = (buckets, countField, medianField, psfField) => {
	const out = new Map();
	(buckets || []).forEach(b => {
		const key = _bedKey(b.val);
		const cur = out.get(key) || { count: 0, median: 0, psf: 0, _bestSubCount: -1 };
		cur.count += (b[countField] || 0);
		const subCount = b[countField] || 0;
		if (subCount > cur._bestSubCount) {
			cur._bestSubCount = subCount;
			if (medianField) cur.median = b[medianField] || 0;
			if (psfField) cur.psf = b[psfField] || 0;
		}
		out.set(key, cur);
	});
	return out;
};

class RentUnitMix extends PureComponent {
	_buildRows() {
		const { rentalStatsRes } = this.props;
		if (!rentalStatsRes) return [];

		const totalBuckets = rentalStatsRes.total_units_by_bed && rentalStatsRes.total_units_by_bed.by_bedrooms
			? rentalStatsRes.total_units_by_bed.by_bedrooms.buckets : [];
		const recentBuckets = rentalStatsRes.unit_mix_listings && rentalStatsRes.unit_mix_listings.by_bedrooms
			? rentalStatsRes.unit_mix_listings.by_bedrooms.buckets : [];

		const totals = _mergeByBedKey(totalBuckets, 'count', null, null);
		const recent = _mergeByBedKey(recentBuckets, 'count', 'median_rent', 'median_rent_psf');

		const allKeys = new Set([...totals.keys(), ...recent.keys()]);
		return Array.from(allKeys).sort((a, b) => a - b).map(key => ({
			key,
			total: totals.get(key) ? totals.get(key).count : 0,
			listed: recent.get(key) ? recent.get(key).count : 0,
			listedRecently: recent.get(key) ? recent.get(key).count : 0
		}));
	}

	_handleClick = (row) => {
		const { history, location } = this.props;
		const base_url = location.pathname.replace('analysis', 'listings');
		history.push(`${base_url}?offering_bedrooms=${_bedSearch(row.key)}`);
	};

	render() {
		const rows = this._buildRows();
		if (rows.length === 0) return null;

		return (
			<Panel lg={12} xl={12} md={12} title={<Fragment>Rental Unit Mix <ToolTip title={"Breakdown by bedroom count from the building's unit records. Listed (5yr) counts rental listings seen in this building over five years — asking rents are not shown at building level because the sample is too small to be meaningful; see the neighborhood market above."} /></Fragment>}>
				<Table responsive striped className="table--bordered dashboard__audience-table">
					<thead>
						<tr>
							<th>Unit Type</th>
							<th>Total</th>
							<th>Listed (5yr)</th>
						</tr>
					</thead>
					<tbody>
						{rows.map((row, i) => (
							<tr key={row.key} onClick={() => this._handleClick(row)} className="tr__link">
								<td><span style={{ backgroundColor: getDefaultChartColors[i % getDefaultChartColors.length], width: "10px", height: "10px", display: "inline-block" }} /> {_bedLabel(row.key)}</td>
								<td>{row.total || '--'}</td>
								<td>{row.listed || '--'}</td>
							</tr>
						))}
					</tbody>
				</Table>
			</Panel>
		);
	}
}

export default RentUnitMix;
